export class DocumentMapNode {
    public id: string = '';
    public isExpanded: boolean = false;
    public label: string = '';
    public text: string = '';
    public page: number = 0;
    public items: DocumentMapNode[] = [];
}
